<div class="section">
  <div class="section-top">
    <h3 class="section-title">Județe</h3>
    <button class="section-btn" (click)="openAddDialog()">
      <img src="../../../../assets/icons/add.svg" alt="add" />
      Adaugă
    </button>
  </div>

  <div class="card-container" *ngIf="showCard">
    <div class="card">
      <label>Activ</label>
      <select [(ngModel)]="activeValue" (change)="rerenderDT()">
        <option *ngFor="let param of parameters" [value]="param.value">
          {{ param.key }}
        </option>
      </select>
    </div>
    <div class="card">
      <label>Public</label>
      <select [(ngModel)]="publicValue" (change)="rerenderDT()">
        <option *ngFor="let param of parameters" [value]="param.value">
          {{ param.key }}
        </option>
      </select>
    </div>
  </div>
  <button
    class="open-filter-btn"
    (click)="toggleCard()"
    [class.active]="showCard"
  >
    <img src="assets/images/filter-icon.png" alt="" />
  </button>

  <div class="table-container">
    <table
      datatable
      [dtOptions]="dtOptions"
      [dtTrigger]="dtTrigger"
      class="row-border hover"
    ></table>
  </div>
  <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
</div>
